import clsx from "clsx"
import { FC } from "react"
import { Trans, useTranslation } from "react-i18next"
import { openTgLink } from "@/helpers/openTgLink"
import { Button } from "@/ui/Button"
import { getHowItWorksImg } from "../../helpers/getHowItWorksImg.ts"
import { HowItWorksImg } from "../HowItWorksImg"
import { HowItWorksText } from "../HowItWorksText"
import { HowItWorksTitle } from "../HowItWorksTitle"
import styles from "./HowItWorksSlide.module.scss"
import { IHowItWorksSlide } from "./types.ts"

const links = {
  en: "https://telegra.ph/Clash-of-Diggers-04-18",
  uk: "https://telegra.ph/Clash-of-Diggers-04-18-2",
  ru: "https://telegra.ph/Clash-of-Diggers-01-09"
}

export const HowItWorksGuideSlide: FC<IHowItWorksSlide> = ({ language }) => {
  const { t } = useTranslation("howItWorks")

  const handleTutorial = (url: string) => {
    openTgLink(url)
  }

  return (
    <div className={clsx(styles.HowItWorksSlide, styles.slide_guide)}>
      <HowItWorksTitle>{t("slides.guide.title")}</HowItWorksTitle>
      <HowItWorksText position="center">
        <Trans
          i18nKey="slides.guide.text1"
          ns="howItWorks"
          components={{ span: <span />, br: <br /> }}
        />
      </HowItWorksText>
      <HowItWorksImg
        className={clsx(styles.HowItWorksSlide_img)}
        src={getHowItWorksImg("guide", language)}
      />
      <HowItWorksText position="center">
        <Trans
          i18nKey="slides.guide.text2"
          ns="howItWorks"
          components={{ span: <span />, br: <br /> }}
        />
      </HowItWorksText>
      <div className={clsx(styles.HowItWorksSlide_buttons)}>
        {Object.entries(links).map(([key, value]) => (
          <Button
            className={clsx(styles.HowItWorksSlide_buttons_item)}
            onClick={() => handleTutorial(value)}
            key={key}
          >
            {key}
          </Button>
        ))}
      </div>
    </div>
  )
}
